<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 添加按钮 -->
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
        </el-form-item>
      </template>
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :labelWidth="'110px'" :form="mform" :formCtrl="mformCtrl" :viewMode="viewMode"
      @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "MakeupList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'compen',
      breadcrumb: [
        { name: "运单管理" },
        { name: "运单补差" },
      ],
      formCtrl: [
        {
          keyName: "predict_loading_date",
          label: "装货日期：",
          placeholder: "请选择日期",
          type: "date",
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchKeyOptions: [
        { label: '车牌号', value: 'license', },
        { label: '运单编号', value: 'order_num', },
        { label: '客户名称', value: 'shname', },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号" },
        { keyName: "license", label: "车牌号" },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "edittime", label: "补差日期" },
        { keyName: "money", label: "补差金额", align:'right', className:'pr30' },
        { keyName: "content", label: "备注信息" },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // this.setModalData(data)
            // this.showDialog()
            this.$router.push(
              `/order/makeupedit?mode=edit&id=${data.id}`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      getTotalProperty: ['money'],
      title: '修改补差金额',
      viewMode: false,
      mform: {},
      mformCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货重量",
          keyName: "inton",
          err: "请填写装货重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货重量",
          keyName: "unton",
          err: "请填写卸货重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "运费",
          keyName: "infreight",
          err: "请填写运费",
          type: "text",
          viewMode: true,
        },
        {
          label: "补差金额",
          keyName: "money",
          err: "请填写补差金额",
          type: "number",
        },
        {
          label: "运费增加",
          keyName: "iscustom",
          type: "radio",
          options: [
            { label: '是', value: '1' },
            { label: '否', value: '2' },
          ],
        },
        {
          label: "利润增加",
          keyName: "iscar",
          type: "radio",
          options: [
            { label: '是', value: '1' },
            { label: '否', value: '2' },
          ],
        },
        {
          label: "备注",
          keyName: "content",
          err: "请填写备注信息",
          type: "textarea",
        },
      ],
    };
  },
  methods: {
    addItem() {
      this.$router.push(
        `/order/makeupdetail?mode=add`
      );
    },
    setModalData(data) {
      this.mformCtrl.map(v => {
        const key = v.keyName
        this.mform[key] = data[key]
      })
      this.mform.id = data.id
      this.mform.orderid = data.orderid
    },
    onModalSubmit() {
      console.log({ ...this.mform })
      let url = `${this.baseUrl}/addedu`
      const params = {
        ...this.mform,
      }
      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>